import React from "react";

export default function BenefitsBox({ items }) {
  if (!items || items.length === 0) return null;
  return (
    <div className="nn-sage-box px-5 py-5 text-white">
      <ul className="space-y-2 font-display italic text-lg">
        {items.map((b) => (
          <li key={b}>– {b}</li>
        ))}
      </ul>
    </div>
  );
}
